var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68791 8.31476C10.3473 10.9734 10.9506 7.89765 12.6438 9.58971C14.2763 11.2217 15.2145 11.5486 13.1462 13.6163C12.8872 13.8245 11.2412 16.3293 5.45648 10.5463C-0.328904 4.7625 2.17447 3.1148 2.38273 2.8558C4.45599 0.782401 4.77732 1.72609 6.40974 3.35806C8.10299 5.05083 5.02852 5.65611 7.68791 8.31476Z",
    stroke: "#130F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.683954edf88f1fe540ac7ec132f6cacb.svg";
export { ForwardRef as ReactComponent };